<script setup lang="ts">
	import { MzTitle, MzLoader } from '@monizze/monizze-components';
	import { useI18n } from 'vue-i18n';
	import { useAuthStore } from '@/stores/auth.ts';
	import { onMounted } from 'vue';
	import { useRoute } from 'vue-router';
	import { getPlatformComingFrom } from '@/utils/platformComingFrom.ts';

	const { t } = useI18n();
	const authStore = useAuthStore();
	const route = useRoute();

	onMounted(() => {
		authStore.linkAccount();
		setTimeout(() => {
			window.location.href = typeof route.query.redirect_uri === 'string' ? route.query.redirect_uri : authStore.targetUrl;
		}, 3000);
	});
</script>

<template>
	<div class="flex flex-col gap-10">
		<mz-title class="text-center" type="h2" :text="t('partner.link-existing.success.title')" />
		<div class="flex flex-col gap-6 items-center">
			<img class="size-[304px]" src="/Mfa/success.svg" :alt="t('partner.link-existing.success.title')" />
			<div class="flex flex-col gap-6 w-full">
				<p>{{ t('partner.link-existing.success.description1') }}</p>
				<p>{{ t('partner.link-existing.success.description2') }}</p>
			</div>
			<div class="flex flex-col gap-2 items-center w-full">
				<mz-loader variant="spinner" />
				<i18n-t :keypath="'partner.link-existing.success.redirection'" tag="p" class="text-sm font-bold text-center">
					<template #platform>
						<b>{{ t(getPlatformComingFrom()) }}</b>
					</template>
				</i18n-t>
			</div>
		</div>
	</div>
</template>
